import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
  action?: ReactNode;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = '查看全部',
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.28em] text-accent-500">
            <span className="inline-block h-px w-6 bg-accent-500/70" />
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl md:text-2xl font-bold tracking-tight text-foreground-50">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">{description}</p>}
      </div>
      {action}
      {linkTo && !action && (
        <Link
          to={linkTo}
          className="group inline-flex shrink-0 items-center gap-1.5 rounded-md border border-background-700 px-3 py-2 text-xs text-foreground-300 transition-colors hover:border-primary-500 hover:text-accent-400"
        >
          {linkLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}